<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Set Up 2FA</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <ng-container *ngIf="!setUpConfirmed">

      <div class="alert alert-info"
           *ngIf="loadingGenerateOTP">
        Loading...
      </div>

      <div *ngIf="!loadingGenerateOTP"
           class="text-center">

        <p class="mb-0">
          Open your authenticator app and scan this QR code.
        </p>

        <qrcode [qrdata]="generateOTPResponse.otp_auth_url"
                [width]="256"
                [errorCorrectionLevel]="'M'"></qrcode>

        <p>
          Or enter the following code manually:
          <br>
          <span style="font-family: monospace">
            {{ getManualCodeFormatted() }}
          </span>
        </p>

        <div class="alert alert-info mb-0">
          If you do not have an authenticator app installed already, we recommend <b>Google Authenticator</b>, available for iOS and Android.
        </div>

      </div>

    </ng-container>

    <ng-container *ngIf="setUpConfirmed">

      <p>
        Enter a code from your authenticator app to verify the setup.
      </p>

      <input type="text" placeholder="XXXXXX"
             class="form-control"
             [(ngModel)]="verifyToken"
             [disabled]="loadingVerifyOTP"
             [class.disabled]="loadingVerifyOTP">

      <div class="alert alert-danger mt-3 mb-0" *ngIf="errorMessage">
        {{ errorMessage }}
      </div>

    </ng-container>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary"
            *ngIf="!setUpConfirmed && !loadingGenerateOTP"
            (click)="setUpConfirmed = true">
      Next
    </button>
    <ng-container *ngIf="setUpConfirmed">
      <button type="button" class="btn btn-primary"
              *ngIf="!loadingVerifyOTP"
              [disabled]="!verifyToken"
              [class.disabled]="!verifyToken"
              (click)="verifyOTP()">
        Verify
      </button>
      <button type="button" class="btn btn-primary disabled"
              *ngIf="loadingVerifyOTP">
        Loading...
      </button>
    </ng-container>
  </div>

</ng-container>
